import { ROUTES, inquiryHref } from './routes';

/**
 * Primary site navigation.
 *
 * Consumed by both the desktop header and the mobile drawer so the two can
 * never fall out of sync. `label` doubles as the visible text and the
 * accessible name.
 */
export const primaryNavigation = [
  { label: 'Home', to: ROUTES.home },
  { label: 'Services', to: ROUTES.services },
];

/**
 * The site's single conversion action. Used by the header, the hero, the
 * closing call to action, and the footer, so the wording and the destination
 * stay identical everywhere.
 */
export const primaryCta = {
  label: 'Bring AI to Your Business',
  to: inquiryHref,
};

/**
 * Footer column: capability deep links. Each `to` must match the `slug` of an
 * entry in utils/capabilitiesData.js, which is what the anchor ids on the
 * Services page are built from.
 */
export const footerCapabilityLinks = [
  { label: 'AI Enablement', to: `${ROUTES.services}#ai-enablement` },
  {
    label: 'AI Integration & Workflow Automation',
    to: `${ROUTES.services}#ai-integration-and-workflow-automation`,
  },
  {
    label: 'Websites & Business Applications',
    to: `${ROUTES.services}#websites-and-business-applications`,
  },
  {
    label: 'Forward-Deployed Engineering',
    to: `${ROUTES.services}#forward-deployed-engineering`,
  },
];

/** Footer column: site links. */
export const footerSiteLinks = [
  { label: 'Home', to: ROUTES.home },
  { label: 'Services & Getting Started', to: ROUTES.services },
  { label: primaryCta.label, to: primaryCta.to },
];

export default primaryNavigation;
